// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__374rm","label":"styles_label__yhM15"};